import React, { useState } from 'react';

const SESSION_STORAGE_KEY = 'fds_last_draft';

export default function RequirementInput({ onGenerate, generating, hasDraft, onRestoreLast }) {
  const [requirementText, setRequirementText] = useState('');
  const [featureTitle, setFeatureTitle] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!requirementText.trim()) return;
    onGenerate(requirementText.trim(), featureTitle.trim() || undefined);
  };

  const handleRestore = () => {
    try {
      const raw = sessionStorage.getItem(SESSION_STORAGE_KEY);
      if (!raw) return;
      const data = JSON.parse(raw);
      if (data && (data.tasks?.length || data.draft?.tasks?.length)) {
        const draft = data.draft || data;
        if (onRestoreLast) onRestoreLast(draft, data.layout || {});
      }
    } catch (err) {
      console.error('Restore draft failed', err);
    }
  };

  const canRestore = (() => {
    try {
      const raw = sessionStorage.getItem(SESSION_STORAGE_KEY);
      if (!raw) return false;
      const data = JSON.parse(raw);
      return data && (data.tasks?.length || data.draft?.tasks?.length);
    } catch {
      return false;
    }
  })();

  return (
    <div className="fds-requirement-input">
      <form onSubmit={handleSubmit} className="fds-requirement-form">
        <div className="fds-field">
          <label className="form-label" htmlFor="fds-feature-title">
            Feature title (optional)
          </label>
          <input
            id="fds-feature-title"
            type="text"
            className="form-control"
            placeholder="e.g. User onboarding flow"
            value={featureTitle}
            onChange={(e) => setFeatureTitle(e.target.value)}
            disabled={generating}
          />
        </div>
        <div className="fds-field">
          <label className="form-label" htmlFor="fds-requirement">
            Feature requirement
          </label>
          <textarea
            id="fds-requirement"
            className="form-control"
            rows={8}
            placeholder="Describe the feature or product requirement in free form..."
            value={requirementText}
            onChange={(e) => setRequirementText(e.target.value)}
            disabled={generating}
          />
        </div>
        <div className="fds-actions d-flex flex-wrap gap-2 align-items-center">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={generating || !requirementText.trim()}
          >
            {generating ? 'Generating…' : 'Build Tasks'}
          </button>
          {canRestore && !hasDraft && (
            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={handleRestore}>
              Restore last
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export { SESSION_STORAGE_KEY };
